'use client';

import { createContext, type ReactNode, useContext } from 'react';
import type { ModalAdapter } from './types';

const ModalAdapterContext = createContext<ModalAdapter | null>(null);

export interface ModalAdapterProviderProps {
  adapter: ModalAdapter;
  children: ReactNode;
}

export function ModalAdapterProvider({ adapter, children }: ModalAdapterProviderProps) {
  return <ModalAdapterContext.Provider value={adapter}>{children}</ModalAdapterContext.Provider>;
}

export function useModalAdapter(): ModalAdapter {
  const adapter = useContext(ModalAdapterContext);
  if (!adapter) {
    throw new Error('useModalAdapter must be used within a ModalAdapterProvider');
  }
  return adapter;
}

/**
 * Optional version - returns null if no provider
 * Useful for gradual migration
 */
export function useModalAdapterOptional(): ModalAdapter | null {
  return useContext(ModalAdapterContext);
}
